<template>
  <div
    class="watchlist-panel"
    :class="{
      'watchlist-panel--open': showPanel,
      'watchlist-panel--bottom-bar': bottomBar,
    }"
  >
    <button
      type="button"
      class="tw-pressable"
      :class="bottomBar ? 'watchlist-bottom-btn' : 'tw-outline-button'"
      @click="openPanel"
    >
      <template v-if="bottomBar">
        <span class="watchlist-bottom-btn__icon-wrap">
          <span class="watchlist-heart">&#9829;</span>
          <span
            class="tw-nav-indicator"
            :class="{ 'tw-nav-indicator--active': showPanel || items.length > 0 }"
          />
        </span>
        <span class="watchlist-bottom-label">{{ $l('watchlist') }}</span>
      </template>
      <template v-else>
        <span class="watchlist-heart">&#9829;</span>
        {{ $l('watchlist') }}
        <span
          v-if="items.length"
          class="tw-rounded-full tw-bg-rose-500 tw-px-2 tw-py-0.5 tw-text-xs tw-font-bold tw-text-white"
        >
          {{ items.length }}
        </span>
      </template>
    </button>

    <b-modal v-model="showPanel" hide-footer :title="$l('watchlist')" centered size="lg">
      <div class="watchlist-content">
        <empty-state
          v-if="!items.length"
          :title="$l('emptyWatchlistTitle')"
          :message="$l('emptyWatchlistMessage')"
        />

        <transition-group v-else name="product-list" tag="div">
          <div v-for="item in items" :key="item.id" class="watchlist-item">
            <img :src="item.imageUrl" class="watchlist-thumb" alt="">
            <div class="watchlist-details">
              <div class="watchlist-title">{{ item.title }}</div>
              <div class="watchlist-price">
                {{ item.lowestPrice }} {{ item.currency }}
              </div>
              <div class="watchlist-stores">{{ item.stores.length }} {{ $l('stores') }}</div>
            </div>
            <div class="watchlist-actions">
              <a
                :href="item.stores[0].itemUrl"
                target="_blank"
                class="watchlist-link tw-pressable"
              >{{ locale === 'he' ? 'צפה' : 'View' }}</a>
              <button
                type="button"
                class="watchlist-remove tw-pressable"
                @click="remove(item.id)"
              >
                {{ locale === 'he' ? 'הסר' : 'Remove' }}
              </button>
            </div>
          </div>
        </transition-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { getWatchlist, removeFromWatchlist } from '@/utils/watchlist';
import EmptyState from './EmptyState.vue';

export default {
  name: 'WatchlistPanel',
  components: {
    EmptyState,
  },
  props: {
    bottomBar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPanel: false,
      items: [],
    };
  },
  watch: {
    showPanel(val) {
      this.$emit('panel-change', val);
    },
  },
  mounted() {
    this.refresh();
    this.$root.$on('watchlist-updated', this.refresh);
  },
  beforeDestroy() {
    this.$root.$off('watchlist-updated', this.refresh);
  },
  methods: {
    openPanel() {
      this.showPanel = true;
    },
    refresh() {
      this.items = getWatchlist();
    },
    remove(productId) {
      removeFromWatchlist(productId);
      this.refresh();
      this.$root.$emit('watchlist-updated');
    },
  },
};
</script>

<style scoped>
.watchlist-panel {
  display: inline-block;
}

.watchlist-panel--bottom-bar {
  display: block;
  width: 100%;
  height: 100%;
}

.watchlist-bottom-btn {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  width: 100%;
  min-height: 3.75rem;
  border: 0;
  border-radius: 0;
  background: transparent;
  padding: 0;
  font-size: 0.6875rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.watchlist-bottom-btn__icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
}

.watchlist-heart {
  color: #f43f5e;
  font-size: 1.125rem;
  line-height: 1;
}

.watchlist-bottom-label {
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 1;
}

.watchlist-panel--open .watchlist-bottom-btn {
  color: #2563eb;
}

.watchlist-panel--open .tw-outline-button {
  color: #2563eb;
}

.watchlist-content {
  max-height: 400px;
  overflow-y: auto;
}

.watchlist-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}

.watchlist-thumb {
  width: 60px;
  height: 60px;
  object-fit: contain;
  border: 1px solid #eee;
  border-radius: 10px;
  flex-shrink: 0;
  background: linear-gradient(145deg, #fff, #f8fafc);
}

.watchlist-details {
  flex: 1;
  min-width: 0;
}

.watchlist-title {
  font-size: 0.9rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.watchlist-price {
  font-size: 0.85rem;
  color: #27ae60;
  margin-top: 2px;
}

.watchlist-stores {
  font-size: 0.8rem;
  color: #888;
}

.watchlist-actions {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
}

.watchlist-link {
  font-size: 0.85rem;
  color: #6190e8;
  text-decoration: none;
}

.watchlist-remove {
  background: none;
  border: none;
  color: #e74c3c;
  font-size: 0.8rem;
  cursor: pointer;
  padding: 0;
}
</style>
